export default "__VITE_ASSET__CTcZWe6p__"